/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { ResponsePath } from './ResponsePath';
import { ResponsePathFromJSON, ResponsePathFromJSONTyped, ResponsePathToJSON } from './ResponsePath';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
 */
export interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  endpointUrl: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  method: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  requestTemplate: string;
  /**
   *
   * @type {Array<ResponsePath>}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  readonly responsePaths: Array<ResponsePath>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  otherHeaders?: { [key: string]: string } | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi interface.
 */
export function instanceOfSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi(
  value: object,
): value is SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('endpointUrl' in value) || value['endpointUrl'] === undefined) return false;
  if (!('method' in value) || value['method'] === undefined) return false;
  if (!('requestTemplate' in value) || value['requestTemplate'] === undefined) return false;
  if (!('responsePaths' in value) || value['responsePaths'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSON(
  json: any,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    endpointUrl: json['endpoint_url'],
    method: json['method'],
    requestTemplate: json['request_template'],
    responsePaths: (json['response_paths'] as Array<any>).map(ResponsePathFromJSON),
    otherHeaders: json['other_headers'] == null ? undefined : json['other_headers'],
  };
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiToJSON(
  value?: Omit<
    SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi,
    'id' | 'credential' | 'responsePaths'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    endpoint_url: value['endpointUrl'],
    method: value['method'],
    request_template: value['requestTemplate'],
    other_headers: value['otherHeaders'],
  };
}
